import ModernAttendanceView from '@/views/employee/ModernAttendanceView.vue'

const routes = [
  {
    path: '/',
    name: 'landing',
    component: () => import('@/views/general/HomeView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/NewLoginView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/auth/ForgotPasswordView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/auth/ResetPasswordView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/auth/RegisterView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/company-setup',
    name: 'company-setup',
    component: () => import('@/views/auth/CompanySetupView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/employee/PostLoginView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/manager/ModernDashboardView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/employee-management',
    name: 'employee-management',
    component: () => import('@/views/manager/EmployeeManagementView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/employee-management/:id',
    name: 'employee-detail',
    component: () => import('@/views/manager/EmployeeDetailView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/performance-kpi',
    name: 'performance-kpi',
    component: () => import('@/views/manager/PerformanceKPIView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/attendance',
    name: 'attendance',
    component: ModernAttendanceView,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/employee/ProfileView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/pdpa-consent',
    name: 'pdpa-consent',
    component: () => import('@/views/employee/PDPAConsentView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/geofence-setup',
    name: 'geofence-setup',
    component: () => import('@/views/manager/GeofenceSetupView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/time-adjustments',
    name: 'time-adjustments',
    component: () => import('@/views/manager/TimeAdjustmentsView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/branch-management',
    name: 'branch-management',
    component: () => import('@/views/manager/BranchManagementView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/attendance-tracking',
    name: 'attendance-tracking',
    component: () => import('@/views/manager/AttendanceTrackingView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/staff-activity-log',
    name: 'staff-activity-log',
    component: () => import('@/views/manager/StaffActivityLogView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/role-management',
    name: 'role-management',
    component: () => import('@/views/manager/RoleManagementView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/dark-mode-demo',
    name: 'dark-mode-demo',
    component: () => import('@/views/general/DarkModeDemoView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/shift-management',
    name: 'shift-management',
    component: () => import('@/views/manager/ShiftManagementView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/leave-management',
    name: 'leave-management',
    component: () => import('@/views/manager/LeaveManagementView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/roster-management',
    name: 'roster-management',
    component: () => import('@/views/manager/RosterManagementView.vue'),
    meta: { requiresAuth: true, requiresPage: 'roster' },
  },
  {
    path: '/task-scheduling',
    name: 'task-scheduling',
    component: () => import('@/views/manager/TaskSchedulingView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/task-board',
    name: 'task-board',
    component: () => import('@/views/manager/TaskBoardView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/leave-request',
    name: 'leave-request',
    component: () => import('@/views/employee/LeaveRequestView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/leave-settings',
    name: 'leave-settings',
    component: () => import('@/views/manager/LeaveSettingsView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/holiday-management',
    name: 'holiday-management',
    component: () => import('@/views/manager/HolidayManagementView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/payroll-export',
    name: 'payroll-export',
    component: () => import('@/views/manager/PayrollExportView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/sales-profit-payroll',
    name: 'sales-profit-payroll',
    component: () => import('@/views/manager/SalesProfitPayrollView.vue'),
    meta: { requiresAuth: true, salesProfit: true },
  },
  {
    path: '/payslip-settings',
    name: 'payslip-settings',
    component: () => import('@/views/manager/PayslipSettingsView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/payroll-rules',
    name: 'payroll-rules',
    component: () => import('@/views/manager/PayrollRulesView.vue'),
    meta: { requiresAuth: true, payrollRules: true },
  },
  {
    path: '/alerts',
    name: 'alerts',
    component: () => import('@/views/manager/AlertsView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/ai-assistant',
    name: 'ai-assistant',
    component: () => import('@/views/manager/AiAssistantView.vue'),
    meta: { requiresAuth: true, requiredEmail: 'work.kuzafri@gmail.com' },
  },
  {
    path: '/mobile-ess',
    name: 'mobile-ess',
    component: () => import('@/views/employee/MobileESSView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/employee-face-registration',
    name: 'employee-face-registration',
    component: () => import('@/views/manager/ModernFaceRegistrationView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/face-attendance',
    name: 'face-attendance',
    component: () => import('@/views/employee/FaceAttendanceView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/my-roster',
    name: 'my-roster',
    component: () => import('@/views/employee/EmployeeRosterView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/attendance-calendar',
    name: 'attendance-calendar',
    component: () => import('@/views/manager/AttendanceCalendarView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/attendance-history',
    name: 'attendance-history',
    component: () => import('@/views/employee/AttendanceHistoryView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('@/views/employee/EmployeeOnboardingView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/employer-onboarding',
    name: 'employer-onboarding',
    component: () => import('@/views/manager/EmployerOnboardingView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' }, // Company creator is admin/manager
  },
  {
    path: '/attendance-settings',
    name: 'attendance-settings',
    component: () => import('@/views/manager/AttendanceSettingsView.vue'),
    meta: { requiresAuth: true, requiresRole: 'manager' },
  },
  {
    path: '/announcements',
    name: 'announcements',
    component: () => import('@/views/manager/AnnouncementManagementView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/superadmin-dashboard',
    name: 'superadmin-dashboard',
    component: () => import('@/views/superadmin/SuperAdminDashboardView.vue'),
    meta: { requiresAuth: true, requiresRole: 'superadmin' },
  },
]

export { routes }
